import { useEffect, useState } from 'react';
import './InterhcangeabilitySummary.css';
import { simulateInterchangeability } from '../../services/InterchangeabilityService';
import { Skeleton } from '@mui/material';

const mockData = {
    "new-both": [{
        id: 1,
        sourcePartNumber: "PN 111-222-333",
        name: "Engine Assembly",
        targets: [
            { id: 0, name: "Engine Assembly", targetPartNumber: "444-333-222" },
            { id: 1, name: "Engine Assembly", targetPartNumber: "444-333-223" },
            { id: 2, name: "Engine Assembly", targetPartNumber: "444-333-224" },
            { id: 3, name: "Engine Assembly", targetPartNumber: "444-333-225" },
        ]
    }],
    "new-one": [{
        id: 1,
        sourcePartNumber: "PN 111-222-333",
        name: "Engine Assembly",
        targets: [
            { id: 0, name: "Engine Assembly", targetPartNumber: "444-333-222" },
            { id: 1, name: "Engine Assembly", targetPartNumber: "444-333-223" },
            { id: 2, name: "Engine Assembly", targetPartNumber: "444-333-224" },
            { id: 3, name: "Engine Assembly", targetPartNumber: "444-333-225" },
        ]
    }],
    "delete-both": [{
        id: 1,
        sourcePartNumber: "PN 111-222-333",
        name: "Engine Assembly",
        targets: [
            { id: 0, name: "Engine Assembly", targetPartNumber: "444-333-222" },
            { id: 1, name: "Engine Assembly", targetPartNumber: "444-333-223" },
            { id: 2, name: "Engine Assembly", targetPartNumber: "444-333-224" },
            { id: 3, name: "Engine Assembly", targetPartNumber: "444-333-225" },
        ]
    }],
    "delete-one": [{
        id: 1,
        sourcePartNumber: "PN 111-222-333",
        name: "Engine Assembly",
        targets: [
            { id: 0, name: "Engine Assembly", targetPartNumber: "444-333-222" },
            { id: 1, name: "Engine Assembly", targetPartNumber: "444-333-223" },
            { id: 2, name: "Engine Assembly", targetPartNumber: "444-333-224" },
            { id: 3, name: "Engine Assembly", targetPartNumber: "444-333-225" },
        ]
    }]
}

const placeholders = {
    "new-both": "No both-ways relations to create",
    "new-one": "No one-way relations to create",
    "delete-both": "No both-ways relations to delete",
    "delete-one": "No one-way relations to delete"
}

export const InterchangeabilitySummary = ({ bothWays, item, okClick, onClose }) => {

    const [summary, setSummmary] = useState({
        "new-both": [],
        "new-one": [],
        "delete-both": [],
        "delete-one": []
    });

    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // console.warn("*Interchangeability changes call", sourcePart, targetPartId)
        setLoading(true);
        simulateInterchangeability(item.sourcePartId, {
            ...item,
            bothWays
        }).then(response => {
            if (response.data.responseCode === 204) {
                let load = response.data.load;
                setSummmary({
                    "new-both": load.groupedNewRelationsBothWays,
                    "new-one": load.groupedNewRelationsOneWay,
                    "delete-both": load.groupedObsoleteRelationsBothWays,
                    "delete-one": load.groupedObsoleteRelationsOneWay
                });
                // setSummmary({
                //     "new-both": [{sourcePartNumber: "A-117-34", targets: load.newRelationsBothWays.map(i => ({id: i, name: "Engine Assembly", targetPartNumber: i}))}],
                //     "new-one": [{sourcePartNumber: "A-117-34", targets: load.newRelationsOneWay.map(i => ({id: i, name: "Engine Assembly", targetPartNumber: i}))}],
                //     "delete-both": [{sourcePartNumber: "A-117-34", targets: load.obsoleteRelations.map(i => ({id: i, name: "Engine Assembly", targetPartNumber: i}))}],
                //     "delete-one": [{sourcePartNumber: "A-117-34", targets: load.newRelationsBothWays.map(i => ({id: i, name: "Engine Assembly", targetPartNumber: i}))}]
                // });
            }
            setLoading(false);
        }).catch(error => {
            setLoading(false);
        })
    }, [item, bothWays])

    return (
        <div className="interchangeability-summary-component">
            <b>
                This transaction will modify existing interchangeabilities. <br></br>
                Below is a list of the changes. Do you want to proceed?
            </b>
            <div className="relation-boxes">
                <b>Both-Ways interchangeability</b>
                <b>One-Way interchangeability</b>
                {!loading && ["new-both", "new-one", "delete-both", "delete-one"].map(box => <div key={box} className="box">
                    <div className="box-header">
                        <i className={`${box.includes("new") ? "icon-add-aircraft" : "icon-delete-new"} ${box.includes("new") ? "new" : "delete"}`}></i>
                        <b className={box.includes("new") ? "new" : "delete"}>{box.includes("new") ? "New Interchangeabilities" : "Removed Interchangeabilities"}</b>
                    </div>
                    <div className="box-content">
                        {!(summary[box]?.length > 0) && <span className='placeholder'>{placeholders[box]}</span>}
                        {summary[box]?.map(g => <div className="interchange-group">
                            {<div>{Object.keys(g)[0]}</div>}
                            {g[Object.keys(g)[0]].map((i) => <div>
                                <span>{box.includes("both") ? "↔ " : "→ "}</span>
                                {i}
                            </div>)}
                            {/* <div>→ PN 265-898-878 (Engine Assembly)</div> */}
                            {/* <div>→ PN 556-898-878 (Engine Assembly)</div>
                            <div>→ PN 879-898-878 (Engine Assembly)</div> */}
                        </div>)}
                        { }
                        {/* <div className="interchange-group">
                            <div>PN 111-222-333 (Engine Assembly)</div>
                            <div>→ PN 265-898-878 (Engine Assembly)</div>
                            <div>→ PN 556-898-878 (Engine Assembly)</div>
                            <div>→ PN 879-898-878 (Engine Assembly)</div>
                        </div> */}
                    </div>
                </div>)}
                {(loading === true) && <>
                    <Skeleton height={100}  variant="rounded"></Skeleton>
                    <Skeleton height={100}  variant="rounded"></Skeleton>
                    <Skeleton height={100}  variant="rounded"></Skeleton>
                    <Skeleton height={100}  variant="rounded"></Skeleton>
                </>
                }
            </div>
            <div className="buttons">
                <button onClick={()=> {okClick?.(); onClose?.()}} className='filled'>Ok</button>
                <button onClick={() => onClose?.()} className='filled danger'>Cancel</button>
            </div>

        </div>
    )
}